import { render, staticRenderFns } from "./FiltroOrdenacao.vue?vue&type=template&id=e79a301e"
import script from "./FiltroOrdenacao.vue?vue&type=script&lang=ts&setup=true"
export * from "./FiltroOrdenacao.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports